const ROUTES = {
  ROOT: "/",
  LOGIN: "/login",
  DASHBOARD_ROOT: "/dashboard",
  DASHBOARD_TOPUP: "/dashboard/topup",
  DASHBOARD_CAMPAIGN: "/dashboard/campaign",
  // DASHBOARD_CUSTOMER: "/dashboard/customers",
  DASHBOARD_PRODUCT: "/dashboard/products",
  DASHBOARD_BANNERS: "/dashboard/banners",
  DASHBOARD_ORDER: "/dashboard/orders",
  DASHBOARD_ACCESS_CONTROL: "/dashboard/accesscontrol",
  DASHBOARD_PROMOS: "/dashboard/promos",
  DASHBOARD_AGENT_MANAGEMENT: "/dashboard/agentManagement",
  DASHBOARD_AGENT_ASSIGNMENT: "/dashboard/agentAssignment",
  DASHBOARD_STORE_LISTING: "/dashboard/storeListing",
  DASHBOARD_TOUR_ASSIGNMENT: "/dashboard/tourAssignment",
  DASHBOARD_SHIFT_DETAIL: "/dashboard/shiftDetail",
  DASHBOARD_PLAN_ASSIGNMENT: "/dashboard/planAssignment",
  DASHBOARD_GLOBAL_PRODUCT: "/dashboard/configurations/products",
  DASHBOARD_PRODUCT_CITY_LEVEL: "/dashboard/productsCityLevel",
  DASHBOARD_CATEGORY_GLOBAL: "/dashboard/configurations/globalCategory",
  DASHBOARD_CATEGORY_CITY_LEVEL: "/dashboard/categoriesCityLevel",
  DASHBOARD_TOUR_CREATION: "/dashboard/tourCreation",
  DASHBOARD_RIDER_MANAGEMENT: "/dashboard/riderManagement",
  DASHBOARD_PROMOS_CITY_LEVEL: "/dashboard/promosCityLevel",
  DASHBOARD_ZONAL_CONFIG: "/dashboard/zonalConfig",
  DASHBOARD_PLAN_CREATION: "/dashboard/planCreation",
  DASHBOARD_DELIVERY_DATE: "/dashboard/deliveryDate",
  DASHBOARD_CNIC_VERIFICATION: "/dashboard/cnicVerification",
  DASHBOARD_WAREHOUSE_STAFF: "/dashboard/warehouseManagement",
  DASHBOARD_METRICS: "/dashboard/configurations/cityMetrics",
  DASHBOARD_PAIYA: "/dashboard/paiyaConfig",
  DASHBOARD_NEWSFEED: "/dashboard/configurations/newsfeed",
  DASHBOARD_LIVEOPS: "/dashboard/liveops",
  DASHBOARD_PAIYA_GIFTS: "/dashboard/paiyaGifts",

};

export default ROUTES;
